import { FC, useMemo } from 'react';
import React from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { useWorkspaces } from 'src/models/workspace/hooks';
import { Table, UserName, WorkspaceBadge } from 'src/common';
import { ColumnsType } from 'antd/lib/table';
import { IWorkspace } from 'src/models/workspace/types';
import { WorkspaceOperations } from './WorkspaceOperations';
import dayjs from 'src/helpers/dayjs';

export interface IArchivedWorkspacesProps {}

export const ArchivedWorkspaces: FC<IArchivedWorkspacesProps> = () => {
  const { t } = useTranslation();
  const { data, loading, refetch } = useWorkspaces();

  const dataSource = useMemo(() => {
    return data?.filter(ws => !ws.isActive).sort((a, b) => a.name.localeCompare(b.name, 'sv'));
  }, [data]);
  const columns = useMemo((): ColumnsType<IWorkspace> => {
    return [
      {
        dataIndex: 'name',
        title: '',
        className: styles.titleCol,
        width: 450,
        render: (val, rec) => <WorkspaceBadge title={val} color={rec.color} mode={'full'} />
      },
      {
        title: t('Common.archived'),
        dataIndex: 'archivedDate',
        render: (_, record) => {
          const { archivedDate } = record;
          return archivedDate ? t('Common.Format.dateTimeFormat', { date: dayjs(archivedDate).toDate() }) : '—';
        }
      },
      {
        title: t('Common.archivedBy'),
        dataIndex: 'archivedBy',
        render: (_, record) =>
          record.archivedBy && <UserName user={record.archivedBy} size={'s'} className={styles.userName} />
      },
      {
        title: '',
        className: styles.actionsCol,
        render: (val, record) => <WorkspaceOperations workspace={record} refetch={refetch} />
      }
    ];
  }, [refetch, t]);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('BidSpaces.archivedBidSpaces')}</h2>
      <Table
        rowKey={'id'}
        dataSource={dataSource}
        loading={loading}
        pagination={false}
        columns={columns}
        className={styles.table}
      />
    </div>
  );
};
